import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            users: [],
            hasError: '',
            filter: '',
            trainings: [],
            waitingList: [],
            historyTrainings: [],
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            }
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.getMyTrainings();
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeMyTrainings')
        },
        chooseUser: chooseUser,
        keymonitor: keymonitor,
        unsubscribe: unsubscribe,
        getMyTrainings: getMyTrainings,
        reset:reset,
        deleteTraining: deleteTraining,
        load: load,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: black;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {
    let _self = this;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        debtor: false
    }

    AdminApiService.getUsers(request)
        .then((response) => {
            _self.users = response.data.results;

            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset(){
    this.users = []
    this.filter = ''
    this.pagination = {
        page: 1,
        limit: 100,
        totalCount: 0
    }
}

function chooseUser(user){
    this.reset();
    this.$topnavbar.$emit('onUserSelected', user)
}


function getMyTrainings() {
    let _self = this;
    AdminApiService.getMyTrainings()
        .then((response) => {
            _self.waitingList = [];
            _self.trainings = response.data.trainings;
            _self.historyTrainings = response.data.historyTrainings;
            let slotIds = _self.trainings.map(t => t.slotId);
            response.data.waitingList.forEach(s => {
                if(s.rsubscribers.includes(session.getUsername()) && !slotIds.includes(s.id)){
                    _self.waitingList.push(s)
                }
            });
        })
        .catch(error => {
            console.log(error);
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function deleteTraining(item) {
    let _self = this;

    swal({
        title: LocService.t("label_remove_training_title"),
        text: LocService.t("label_remove_training_title_are_you_sure") + " ( " + item.date + " - " + item.startAt + " )",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        AdminApiService.deleteTraining(item.id)
            .then((response) => {
                _self.getMyTrainings();
                console.log("")
                swal(LocService.t("label_success"), LocService.t("label_success_remove_training"), 'success')
                // this.getSlots(this.currentDate)
                // this.getTrainings()
                _self.$trainingBus.$emit('refreshTrainings')
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    })


}

function unsubscribe(slot){
    let _self = this;

    swal({
        title: LocService.t("label_remove_waiting_list"),
        text: LocService.t("label_remove_waiting_list_are_you_sure") + " ( " + slot.date + " - " + slot.startAt + " )",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            slotId: slot.id
        }
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});
        AdminApiService.unsubscribeToSlot(model)
            .then((response) => {
                _self.getMyTrainings();
                swal(LocService.t("label_success"), LocService.t("label_success_remove_to_waiting_list"), 'success')
                // this.getSlots(this.currentDate)
                // this.getTrainings()
                _self.$trainingBus.$emit('refreshTrainings')
            })
            .catch(error => {
                // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    })
}


// WEBPACK FOOTER //
// ./src/modals/MyTrainingsModal.js